import {
    Button,
    Dialog,
    DialogContent,
    DialogTrigger,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@repo/shadcn';
import { CellContext, ColumnDef } from '@tanstack/react-table';
import { ChevronDownIcon, Loader2Icon, Trash } from 'lucide-react';
import { toast } from 'sonner';

import { ButtonGroup } from '@components/ui/button';

import { toastError } from '@/utils';

import {
    useDeleteGenericMutation,
    useUpdateGenericMutation,
} from '../../../../features/slice/products/generic/generic-api-slice';
import { GenericForm } from '../generic-form.component';

const ActionCell = ({ row }: CellContext<any, unknown>) => {
    const [deleteGeneric, { isLoading: isDeleting }] =
        useDeleteGenericMutation();
    const [editGeneric, { isLoading: isEditing }] = useUpdateGenericMutation();

    const handleDeleteGeneric = async (genericId: string) => {
        const confirmed = window.confirm(
            'Are you sure you want to delete this generic?',
        );
        if (!confirmed) return;

        try {
            await deleteGeneric(genericId).unwrap();
            toast.success('Generic has been deleted');
        } catch (error) {
            toastError(
                error,
                'useGenericList: handleDeleteGeneric -> Failed to delete generic.',
            );
        }
    };

    const handleEdit = async (data: any) => {
        try {
            await editGeneric({
                id: row.original.id,
                name: data.name,
                description: data.description,
            }).unwrap();
            toast.success('Generic has been updated');
        } catch (error) {
            toastError(error, 'Failed to edit generic.');
        }
    };

    return (
        <div className={'flex justify-end'}>
            <ButtonGroup>
                <Dialog>
                    <DialogTrigger>
                        <Button type={'button'} variant={'outline'}>
                            Edit
                        </Button>
                    </DialogTrigger>
                    <DialogContent>
                        <GenericForm
                            initialValues={{
                                name: row.original.name,
                            }}
                            onSubmit={handleEdit}
                            title="Edit Generic"
                            isLoading={isEditing}
                        />
                    </DialogContent>
                </Dialog>
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="outline" className="!pl-2">
                            <ChevronDownIcon />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        align="end"
                        className="[--radius:1rem]"
                    >
                        <DropdownMenuGroup>
                            <DropdownMenuItem
                                className={'flex gap-2 text-destructive'}
                                onClick={() =>
                                    handleDeleteGeneric(row.original.id)
                                }
                            >
                                {isDeleting ? (
                                    <Loader2Icon className={'animate-spin'} />
                                ) : (
                                    <>
                                        <Trash className={'size-4'} />
                                        Delete
                                    </>
                                )}
                            </DropdownMenuItem>
                        </DropdownMenuGroup>
                    </DropdownMenuContent>
                </DropdownMenu>
            </ButtonGroup>
        </div>
    );
};

export const genericListColumns: ColumnDef<any>[] = [
    {
        accessorKey: 'name',
        header: 'Brand Name',
        cell: ({ row }) => {
            return (
                <div
                    title={row.getValue('name')}
                    // className=" w-[200px] cursor-pointer truncate"
                >
                    {row.getValue('name')}
                </div>
            );
        },
    },

    {
        accessorKey: 'actions',
        header: () => <div className="text-right">Actions</div>,
        cell: ActionCell,
    },
];
